/**
 * React-intl message descriptors for address validation errors
 *
 * These message descriptors provide default English translations for validation errors.
 * Import and use with react-intl's formatMessage or FormattedMessage components.
 * @example
 * import { useIntl } from 'react-intl';
 * import { validationMessages } from '@shipstation/client-common/address';
 *
 * const intl = useIntl();
 * const errorMessage = intl.formatMessage(validationMessages.required);
 */

export const validationMessages = {
  required: {
    id: 'validation.required',
    defaultMessage: 'This field is required',
    description: 'Error message when a required field is empty',
  },
  emailInvalid: {
    id: 'validation.email.invalid',
    defaultMessage: 'Please enter a valid email address',
    description: 'Error message when email format is invalid',
  },
  phoneInvalid: {
    id: 'validation.phone.invalid',
    defaultMessage: 'Please enter a valid phone number',
    description: 'Error message when phone format is invalid',
  },
  zipCodeInvalid: {
    id: 'validation.zipCode.invalid',
    defaultMessage: 'Please enter a valid ZIP code',
    description: 'Error message when US ZIP code format is invalid',
  },
  postalCodeInvalid: {
    id: 'validation.postalCode.invalid',
    defaultMessage: 'Please enter a valid postal code',
    description: 'Error message when postal code format is invalid',
  },
  valueInvalid: {
    id: 'validation.value.invalid',
    defaultMessage: 'Please enter a valid value',
    description: 'Generic error message when field value is invalid',
  },
  maxLength: {
    id: 'validation.maxLength',
    defaultMessage: 'Maximum {max} characters allowed',
    description: 'Error message when field exceeds maximum length',
  },
  minLength: {
    id: 'validation.minLength',
    defaultMessage: 'Minimum {min} characters required',
    description: 'Error message when field is below minimum length',
  },
} as const;

/**
 * Type-safe message descriptor type for TypeScript consumers
 */
export type ValidationMessageDescriptor = (typeof validationMessages)[keyof typeof validationMessages];
